export default class User {
    public id: number;
    public firstName: string;
    public lastName: string;
    public username: string;
    public jwtToken: string;
    public recipient: string;
    public role: number;
    public listModules: string[];

    public constructor() {
        this.id = 0;
        this.firstName = "";
        this.lastName = "";
        this.username = "";
        this.jwtToken = "";
        this.recipient = "";
        this.role = -1;
        this.listModules = [];
    }
}